import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "info-section-tutorial-tile" }
const _hoisted_2 = { class: "info-section-tutorial-tile__icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "info-section-tutorial-tile__text" }
const _hoisted_6 = ["href"]

import Tutorial from '@/assets/images/infoSection/tutorial.png';

type Props = {
  title: string;
  text: string;
  icon?: string;
  submitIcon?: string;
  link: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoSectionTutorialTile',
  props: {
    title: {},
    text: {},
    icon: { default: Tutorial },
    submitIcon: { default: '$chevronRight' },
    link: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _directive_orphans = _resolveDirective("orphans")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: props.icon
      }, null, 8, _hoisted_3),
      _createVNode(_component_v_divider, {
        class: "info-section-tutorial-tile__divider",
        vertical: "",
        opacity: "1"
      })
    ]),
    _createElementVNode("h3", {
      class: "info-section-tutorial-tile__title",
      innerHTML: props.title
    }, null, 8, _hoisted_4),
    _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_5, [
      _createTextVNode(_toDisplayString(props.text), 1)
    ])), [
      [_directive_orphans]
    ]),
    _createElementVNode("a", {
      class: "info-section-tutorial-tile__submit",
      href: props.link,
      target: "_blank"
    }, [
      _createVNode(_component_v_icon, { color: "white" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.submitIcon), 1)
        ]),
        _: 1
      })
    ], 8, _hoisted_6)
  ]))
}
}

})